interface EventDataPayload {
  questionsToken?: string;
  orderNo?: string;
  appointmentId?: string;
  startTime?: string;
  endTime?: string;
  locationType?: string;
  serviceId?: string;
}

export type EventName =
  | 'BOKA_CLOSED'
  | 'BOOKING_COMPLETE'
  | 'QUESTIONS_ANSWERED'
  | 'QUESTIONS_CLOSED';

export const sendEventToParent = (
  eventName: EventName,
  data?: EventDataPayload,
): void => {
  if (window.parent !== window) {
    window.parent.ikea.pubsub.publish(`BOKA/${eventName}`, data);
  }
};
